var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"SVGRepo_bgCarrier","strokeWidth":"0","key":0}),React.createElement("g",{"id":"SVGRepo_tracerCarrier","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("g",{"id":"SVGRepo_iconCarrier","key":2},React.createElement("path",{"d":"M7 12L9.89075 14.8907V14.8907C9.95114 14.951 10.049 14.9511 10.1094 14.8907V14.8907L17 8","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}))]);
}

Check.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
